import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import {
  getProjectByIdService,
  getProjectByUserId,
} from "../../../../Services/projectService";
import { toast } from "react-toastify";
import { createObservation } from "../../../../Services/observationService";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { t } from "../../../../utils/translate";
import ImageUpload from "../../../../components/FileUpload";
import MainLayout from "../../../components/layout/MainLayout";

const ObservationFormPage = () => {
  const [isProjectOpen, setIsProjectOpen] = useState(true);
  const currentLanguage = useSelector(
    (state) => state?.global?.current_language
  );
  const [loading, setLoading] = useState(false);
  const [projectId, setProjectId] = useState(null);
  const [projects, setProjects] = useState([]);
  const adminId = useSelector((state) => state?.auth?.loggedInUser?._id);
  const { accessLevel: roleOfUser } = useSelector((state) => state?.project);
  const navigate = useNavigate();
  const [projectDetail, setProjectDetail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [observationData, setObservationData] = useState([]);
  const [mediaAttachment, setMediaAttachment] = useState("");
  const [errors, setErrors] = useState({});
  const [action, setAction] = useState({
    takeAction: { isTakeAction: false, value: "" },
    furtherAction: { isFurtherAction: false, value: "" },
  });
  const [selectedOption, setSelectedOption] = useState({
    takeAction: "",
    furtherAction: "",
  });

  const [riskAssessment, setRiskAssessment] = useState({
    value: "",
    riskLevel: "",
  });

  const [observationDetails, setObservationDetails] = useState({
    observationCategory: "",
    observationDescription: "",
  });

  const [observerDetails, setObserverDetails] = useState({
    observerDetail: "",
    observerDate: new Date().toISOString().split("T")[0],
  });

  const [yourNames, setYourNames] = useState({
    yourName: "",
    anonymous: "",
  });

  const [formData, setFormData] = useState({
    projectDetail: {
      projectName: "",
      observationTitle: "",
      Observationisrelatedto: "",
      Didyoutakeaction: "",
      Isthereneedforfurtheraction: "",
      dateOfObservation: new Date().toISOString().split("T")[0],
      WhatIsObserved: "",
    },
  });

  const [searchTerm, setSearchTerm] = useState("");

  const filteredProjects = projects.filter((project) => {
    const searchLower = searchTerm.toLowerCase();
    const nameMatch = project.projectName.toLowerCase().includes(searchLower);
    const numberMatch = project.projectNumber.toString().includes(searchLower);
    return nameMatch || numberMatch;
  });

  useEffect(() => {
    if (!projectId) return;
    getProjectDetail();
  }, [projectId]);

  const validateForm = () => {
    const newErrors = {};

    if (!observerDetails.observerDetail) {
      newErrors.observationTitle = "Observation Title is required";
    }

    if (!observationDetails.observationCategory) {
      newErrors.observationCategory = "Observation Category is required";
    }

    if (!observationDetails.observationDescription) {
      newErrors.observationDescription = "Observation Description is required";
    }

    if (!selectedOption.takeAction) {
      newErrors.takeAction = "Please select if you took action";
    }

    if (!selectedOption.furtherAction) {
      newErrors.furtherAction = "Please select if further action is needed";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setIsLoading(true);
    try {
      const payload = {
        ...formData,
        userId: projectDetail?.userId,
        projectNumber: projectDetail?.projectNumber,
        projectId: projectId,
        ...observationData,
        notificationToAdminCreate: roleOfUser === 0 ? false : true,
        observationAction: action,
        observationMedia: mediaAttachment,
        riskAssessment,
        observationDetails,
        observerDetails,
        status: action?.furtherAction?.isFurtherAction ? "latest" : "under",
        yourNames,
      };

      const response = await createObservation(payload);
      if (response?.success) {
        toast.success(t("observationFormCreatedSuccessfully"));
        navigate(`/admin/observations`);
      } else {
        toast.error(t("thereIsSomeError"));
      }
    } catch (error) {
      return error;
    } finally {
      setIsLoading(false);
    }
  };

  const getProjectDetail = async () => {
    const response = await getProjectByIdService(projectId);
    setProjectDetail(response?.data?.project);
  };

  const handleMediaAttachment = (url) => {
    setMediaAttachment("");
  };

  const handleOptionChange = (e, actionType) => {
    const value = e.target.value;
    setSelectedOption((prev) => ({ ...prev, [actionType]: value }));

    if (value === "yes") {
      setAction((prevState) => ({
        ...prevState,
        [actionType]: {
          ...prevState[actionType],
          [`is${capitalizeFirstLetter(actionType)}`]: true,
        },
      }));
    } else {
      setAction((prevState) => ({
        ...prevState,
        [actionType]: {
          ...prevState[actionType],
          [`is${capitalizeFirstLetter(actionType)}`]: false,
          value: "",
        },
      }));
    }
  };

  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  const handleInputChange = (e, section, field) => {
    if (section === "observerDetails") {
      setObserverDetails({
        ...observerDetails,
        [field]: e.target.value,
      });
    } else if (section === "observationDetails") {
      setObservationDetails({
        ...observationDetails,
        [field]: e.target.value,
      });
    } else if (section === "riskAssessment") {
      setRiskAssessment({
        ...riskAssessment,
        [field]: e.target.value,
      });
    } else if (section === "yourNames") {
      setYourNames({
        ...yourNames,
        [field]: e.target.value,
      });
    } else if (section === "action") {
      setAction({
        ...action,
        [field]: {
          ...action[field],
          value: e.target.value,
        },
      });
    }
  };

  useEffect(() => {
    if (!adminId) return;
    if (adminId) {
      getProjectsDataByUserId(adminId);
    }
  }, [adminId]);

  const handleSelect = (e) => {
    setProjectId(e.target.value);
  };

  const handleConfirm = () => {
    if (projectId) {
      setIsProjectOpen(false);
    } else {
      toast.error("Please select a project.");
    }
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  const getProjectsDataByUserId = async (id) => {
    if (!id) return;

    setLoading(true);

    try {
      const responseData = await getProjectByUserId(id);
      if (responseData) {
        setProjects(responseData?.data);
      } else {
        setProjects([]);
      }
    } catch (err) {
      console.error("Error fetching projects:", err);
      setProjects([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <MainLayout title={"Observation Form"}>
      <div className="bg-white">
        <div className="border-b border-gray-300">
          <div className="container mx-auto px-4 py-4 flex flex-col md:flex-row gap-5 justify-between items-center">
            <p className="text-xl font-bold uppercase text-gray-800">
              {t("observation")}
            </p>
            <div className="flex flex-col gap-7">
              <div className="flex justify-between items-center mb-5">
                <div className="flex flex-col sm:flex-row justify-center items-center gap-4">
                  <div className="flex justify-between rounded-md items-center gap-6 border border-gray-300 px-3 py-2 bg-white">
                    <p className="text-sm font-medium text-gray-600">
                      {t("projectName")}
                    </p>
                    <p className="text-base font-semibold uppercase">
                      {projectDetail?.projectName || (
                        <div role="status">
                          <svg
                            aria-hidden="true"
                            className="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                            viewBox="0 0 100 101"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                              fill="currentColor"
                            />
                            <path
                              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                              fill="currentFill"
                            />
                          </svg>
                        </div>
                      )}
                    </p>
                  </div>
                  <div className="flex justify-between rounded-md items-center gap-6 border border-gray-300 px-3 py-2 bg-white">
                    <p className="text-sm font-medium text-gray-600">
                      {t("projectNumber")}
                    </p>
                    <p className="text-base font-semibold">
                      {projectDetail?.projectNumber || (
                        <div role="status">
                          <svg
                            aria-hidden="true"
                            className="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                            viewBox="0 0 100 101"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                              fill="currentColor"
                            />
                            <path
                              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                              fill="currentFill"
                            />
                          </svg>
                        </div>
                      )}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <form onSubmit={handleSubmit} className="bg-gray-50">
          <div className="container mx-auto px-4 py-8">
            <p className="text-lg font-semibold mb-3 text-gray-800">
              {t("observerDetail")}:
            </p>
            <div className="flex flex-wrap justify-between items-start gap-6 w-full mb-10">
              <div className="w-full lg:w-[calc(50%-12px)] flex flex-col md:flex-row justify-between gap-4">
                <label className="text-sm font-medium text-gray-700 w-full md:w-[30%] pt-2">
                  {t("observation-title")}
                  <span className="text-red-500 text-lg">*</span>
                </label>
                <div className="w-full md:w-[70%]">
                  <input
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    type="text"
                    placeholder={t("observation-title")}
                    value={observerDetails.observerDetail}
                    onChange={(e) =>
                      handleInputChange(e, "observerDetails", "observerDetail")
                    }
                  />
                  {errors.observationTitle && (
                    <span className="text-red-500 text-sm mt-1 block">
                      {errors.observationTitle}
                    </span>
                  )}
                </div>
              </div>
              <div className="w-full lg:w-[calc(50%-12px)] flex flex-col md:flex-row justify-between gap-4">
                <label className="text-sm font-medium text-gray-700 w-full md:w-[30%] pt-2">
                  {t("observationDate")}
                  <span className="text-red-500 text-lg">*</span>
                </label>
                <div className="w-full md:w-[70%]">
                  <input
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    type="date"
                    placeholder="Date of Observation"
                    defaultValue={new Date().toISOString().split("T")[0]}
                    value={observerDetails.observerDate}
                    onChange={(e) =>
                      handleInputChange(e, "observerDetails", "observerDate")
                    }
                  />
                </div>
              </div>
            </div>

            <p className="text-lg font-semibold mb-3 text-gray-800">
              {t("observationDetails")}:
            </p>
            <div className="flex flex-wrap justify-between items-start gap-6 w-full mb-10">
              <div className="w-full lg:w-[calc(50%-12px)] flex flex-col md:flex-row justify-between gap-4">
                <label className="text-sm font-medium text-gray-700 w-full md:w-[30%] pt-2 whitespace-nowrap">
                  {t("observationCategory")}
                  <span className="text-red-500 text-lg">*</span>
                </label>
                <div className="w-full md:w-[70%]">
                  <select
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white"
                    value={observationDetails.observationCategory}
                    onChange={(e) =>
                      handleInputChange(
                        e,
                        "observationDetails",
                        "observationCategory"
                      )
                    }
                  >
                    <option value="">{t("Observationisrelatedto")}</option>
                    <option value="safety">{t("safety")}</option>
                    <option value="quality">{t("quality")}</option>
                    <option value="environmental">{t("environmental")}</option>
                    <option value="efficiency">{t("efficiency")}</option>
                    <option value="equipment">{t("equipment")}</option>
                    <option value="positive">{t("positive")}</option>
                    <option value="other">{t("other")}</option>
                  </select>
                  {errors.observationCategory && (
                    <span className="text-red-500 text-sm mt-1 block">
                      {errors.observationCategory}
                    </span>
                  )}
                </div>
              </div>

              <div className="w-full lg:w-[calc(50%-12px)] flex flex-col md:flex-row justify-between gap-4">
                <label className="text-sm font-medium text-gray-700 w-full md:w-[30%] pt-2">
                  {t("observationDescription")}:
                  <span className="text-red-500 text-lg">*</span>
                </label>
                <div className="w-full md:w-[70%]">
                  <textarea
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 min-h-[100px]"
                    placeholder={t("What-Is-Observed")}
                    value={observationDetails.observationDescription}
                    onChange={(e) =>
                      handleInputChange(
                        e,
                        "observationDetails",
                        "observationDescription"
                      )
                    }
                  ></textarea>
                  {errors.observationDescription && (
                    <span className="text-red-500 text-sm mt-1 block">
                      {errors.observationDescription}
                    </span>
                  )}
                </div>
              </div>

              <div className="w-full lg:w-[calc(50%-12px)] flex flex-col md:flex-row gap-4">
                <label className="text-sm font-medium text-gray-700 w-full md:w-[30%] pt-2">
                  {t("Didyoutakeaction")}
                  <span className="text-red-500 text-lg">*</span>
                </label>
                <div className="w-full md:w-[70%]">
                  <div className="flex gap-6 mb-2">
                    <div className="flex items-center gap-2">
                      <input
                        type="radio"
                        id="takeActionYes"
                        name="takeAction"
                        value="yes"
                        onChange={(e) => handleOptionChange(e, "takeAction")}
                        checked={selectedOption.takeAction === "yes"}
                        className="w-4 h-4 text-blue-600"
                      />
                      <label
                        htmlFor="takeActionYes"
                        className="text-sm text-gray-700"
                      >
                        {t("Yes")}
                      </label>
                    </div>
                    <div className="flex items-center gap-2">
                      <input
                        type="radio"
                        id="takeActionNo"
                        name="takeAction"
                        value="no"
                        onChange={(e) => handleOptionChange(e, "takeAction")}
                        checked={selectedOption.takeAction === "no"}
                        className="w-4 h-4 text-blue-600"
                      />
                      <label
                        htmlFor="takeActionNo"
                        className="text-sm text-gray-700"
                      >
                        {t("No")}
                      </label>
                    </div>
                  </div>
                  {errors.takeAction && (
                    <span className="text-red-500 text-sm block mb-2">
                      {errors.takeAction}
                    </span>
                  )}
                  {action.takeAction.isTakeAction && (
                    <textarea
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 min-h-[80px]"
                      placeholder={t("describeAction")}
                      value={action.takeAction.value}
                      onChange={(e) =>
                        handleInputChange(e, "action", "takeAction")
                      }
                    ></textarea>
                  )}
                </div>
              </div>

              <div className="w-full lg:w-[calc(50%-12px)] flex flex-col md:flex-row gap-4">
                <label className="text-sm font-medium text-gray-700 w-full md:w-[30%] pt-2">
                  {t("describeFurtherAction")}
                  <span className="text-red-500 text-lg">*</span>
                </label>
                <div className="w-full md:w-[70%]">
                  <div className="flex gap-6 mb-2">
                    <div className="flex items-center gap-2">
                      <input
                        type="radio"
                        id="furtherActionYes"
                        name="furtherAction"
                        value="yes"
                        onChange={(e) => handleOptionChange(e, "furtherAction")}
                        checked={selectedOption.furtherAction === "yes"}
                        className="w-4 h-4 text-blue-600"
                      />
                      <label
                        htmlFor="furtherActionYes"
                        className="text-sm text-gray-700"
                      >
                        {t("Yes")}
                      </label>
                    </div>
                    <div className="flex items-center gap-2">
                      <input
                        type="radio"
                        id="furtherActionNo"
                        name="furtherAction"
                        value="no"
                        onChange={(e) => handleOptionChange(e, "furtherAction")}
                        checked={selectedOption.furtherAction === "no"}
                        className="w-4 h-4 text-blue-600"
                      />
                      <label
                        htmlFor="furtherActionNo"
                        className="text-sm text-gray-700"
                      >
                        {t("No")}
                      </label>
                    </div>
                  </div>
                  {errors.furtherAction && (
                    <span className="text-red-500 text-sm block mb-2">
                      {errors.furtherAction}
                    </span>
                  )}
                  {action.furtherAction.isFurtherAction && (
                    <textarea
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 min-h-[80px]"
                      placeholder={t("describeFurtherAction")}
                      value={action.furtherAction.value}
                      onChange={(e) =>
                        handleInputChange(e, "action", "furtherAction")
                      }
                    ></textarea>
                  )}
                </div>
              </div>

              <div className="w-full lg:w-[calc(50%-12px)] flex flex-col md:flex-row justify-between gap-4">
                <label className="text-sm font-medium text-gray-700 w-full md:w-[30%] pt-2">
                  {t("mediaAttachment")}
                </label>
                <div className="w-full md:w-[70%] flex flex-col gap-2">
                  <ImageUpload
                    handleDeleteDocument={handleMediaAttachment}
                    status={mediaAttachment ? true : false}
                    setMediaAttachment={setMediaAttachment}
                    isObservationMedia={true}
                  />
                  {mediaAttachment && (
                    <div className="border max-w-[150px] mt-2">
                      <img
                        src={mediaAttachment || "/placeholder.svg"}
                        alt="media"
                        className="w-full h-auto"
                      />
                    </div>
                  )}
                </div>
              </div>

              <div className="w-full lg:w-[calc(50%-12px)] flex flex-col md:flex-row justify-between gap-4 relative">
                <div className="w-full flex flex-col md:flex-row items-center gap-4 mt-4">
                  <label className="text-sm font-medium text-gray-700 w-full md:w-[30%] whitespace-nowrap">
                    {"Risk Level"}:
                  </label>
                  <select
                    onChange={(e) =>
                      handleInputChange(e, "riskAssessment", "riskLevel")
                    }
                    value={riskAssessment.riskLevel}
                    className="w-full md:w-[70%] px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white"
                  >
                    <option value="">{"Please Select The Risk"}</option>
                    <option value="low">🟢 {"Low"}</option>
                    <option value="medium">🟡 {"Medium"}</option>
                    <option value="high">🔴 {"High"}</option>
                  </select>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-6 justify-between mt-10">
              <div className="w-full lg:w-[calc(50%-12px)] flex flex-col md:flex-row justify-between gap-4">
                <label
                  htmlFor="your_name"
                  className="text-sm font-medium text-gray-700 w-full md:w-[30%] pt-2 whitespace-nowrap"
                >
                  {"Your Name"}
                </label>
                <input
                  type="text"
                  id="your_name"
                  placeholder={"Type Your Name"}
                  value={yourNames?.yourName}
                  onChange={(e) =>
                    handleInputChange(e, "yourNames", "yourName")
                  }
                  className="w-full md:w-[70%] px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
            </div>

            <div className="text-center mt-16">
              <button
                type="submit"
                className="px-6 py-3 bg-blue-600 text-white font-medium rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors"
              >
                {isLoading ? t("loading") : t("sendforReview")}
              </button>
            </div>
          </div>
        </form>
      </div>

      {isProjectOpen && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4 transition-opacity duration-300 ease-in-out">
          <div className="bg-white rounded-2xl shadow-xl p-8 w-full max-w-md mx-4 transform transition-all duration-300 ease-out scale-100 opacity-100">
            <h2 className="text-2xl font-bold mb-6 text-center text-gray-800">
              Select Project for New Approval Form
            </h2>

            {/* Search input */}
            <div className="relative mb-4">
              <input
                type="text"
                placeholder="Search by project name or number..."
                className="w-full bg-gray-50 border border-gray-300 rounded-xl p-3 pl-10 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none text-gray-500">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
              {searchTerm && (
                <button
                  className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-500 hover:text-gray-700"
                  onClick={() => setSearchTerm("")}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                      clipRule="evenodd"
                    />
                  </svg>
                </button>
              )}
            </div>

            {projects.length === 0 ? (
              <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-xl text-red-700 text-center">
                <div className="flex items-center justify-center mb-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5 mr-2"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span className="font-semibold">No Projects Available</span>
                </div>
                <p className="text-sm">
                  Please create a new project to continue.
                </p>
              </div>
            ) : filteredProjects.length === 0 ? (
              <div className="mb-6 p-4 bg-yellow-50 border border-yellow-200 rounded-xl text-yellow-700 text-center">
                <div className="flex items-center justify-center mb-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5 mr-2"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span className="font-semibold">No Matching Projects</span>
                </div>
                <p className="text-sm">
                  No projects match your search. Try different keywords.
                </p>
              </div>
            ) : (
              <div className="max-h-60 overflow-y-auto mb-6 bg-gray-50 border border-gray-300 rounded-xl">
                {filteredProjects.map((project) => (
                  <div
                    key={project._id}
                    className={`p-3 border-b border-gray-200 last:border-b-0 cursor-pointer hover:bg-blue-50 transition-colors duration-200 ${
                      projectId === project._id ? "bg-blue-100" : ""
                    }`}
                    onClick={() => setProjectId(project._id)}
                  >
                    <div className="flex items-center">
                      <div className="flex-1">
                        <div className="font-medium text-gray-800">
                          {project.projectName}
                        </div>
                        <div className="text-sm text-gray-600">
                          #{project.projectNumber}
                        </div>
                      </div>
                      {projectId === project._id && (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-5 w-5 text-blue-600"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fillRule="evenodd"
                            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                            clipRule="evenodd"
                          />
                        </svg>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}

            <div className="flex items-center space-x-2 my-6">
              <div className="flex-1 border-t border-gray-200"></div>
              <span className="text-xs font-medium text-gray-500 px-3 bg-white">
                OR
              </span>
              <div className="flex-1 border-t border-gray-200"></div>
            </div>

            <Link to="/admin/project/create-new-project" className="block mb-6">
              <button className="w-full flex items-center justify-center gap-2 py-3 px-4 border-2 border-dashed border-gray-300 rounded-xl text-gray-700 hover:bg-gray-50 hover:border-blue-400 hover:text-blue-600 transition-all duration-200 font-medium">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                    clipRule="evenodd"
                  />
                </svg>
                Create New Project
              </button>
            </Link>

            <div className="grid grid-cols-2 gap-4 mt-6">
              <button
                onClick={handleGoBack}
                className="w-full bg-white border border-gray-300 text-gray-700 font-medium py-3 px-4 rounded-xl hover:bg-gray-50 hover:border-gray-400 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-gray-300"
              >
                Back
              </button>
              <button
                onClick={handleConfirm}
                className={`w-full font-medium py-3 px-4 rounded-xl transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                  !projectId && filteredProjects.length > 0
                    ? "bg-blue-400 text-white cursor-not-allowed opacity-70"
                    : "bg-blue-600 text-white hover:bg-blue-700 shadow-md hover:shadow-lg"
                }`}
                disabled={!projectId && filteredProjects.length > 0}
              >
                Continue
              </button>
            </div>
          </div>
        </div>
      )}
    </MainLayout>
  );
};

export default ObservationFormPage;
